import * as fromGuardsActions from '../actions/guard-patrol.actions';
import {
  GuardPatrolState,
  initialGuardPatrolState,
} from '../states/guard-patrol.state';

export function guardPatrolReducer(
  state: GuardPatrolState = initialGuardPatrolState,
  action: fromGuardsActions.GuardPatrolActions
): GuardPatrolState {
  switch (action.type) {
    case '[Guard Patrol] Load User Patrol Data':
    case '[Guard Patrol] Start Patrolling':
    case '[Guard Patrol] End Patrolling':
    case '[Guard Patrol] Get Patrol Sessions':
    case '[Guard Patrol] Get User Patrol Sessions':
    case '[Guard Patrol] Get Patrol Violations':
    case '[Guard Patrol] Record Patrol Violation':
      return {
        ...state,
        loading: true,
        error: null,
      };

    case '[Guard Patrol] Load User Patrol Data Success':
      return {
        ...state,
        loading: false,
        userPatrolData: (action as fromGuardsActions.LoadUserPatrolDataSuccess)
          .payload,
        assignedGeofences: (
          action as fromGuardsActions.LoadUserPatrolDataSuccess
        ).payload.assignedPatrollingGeofences,
        hasPatrollingAssignment: (
          action as fromGuardsActions.LoadUserPatrolDataSuccess
        ).payload.hasPatrollingAssignment,
        statistics: (action as fromGuardsActions.LoadUserPatrolDataSuccess)
          .payload.statistics,
        patrolViolations: (
          action as fromGuardsActions.LoadUserPatrolDataSuccess
        ).payload.violations,
      };

    case '[Guard Patrol] Start Patrolling Success':
      return {
        ...state,
        loading: false,
        currentPatrolSession: (
          action as fromGuardsActions.StartPatrollingSuccess
        ).payload,
      };

    case '[Guard Patrol] End Patrolling Success':
      return {
        ...state,
        loading: false,
        currentPatrolSession: null,
      };

    case '[Guard Patrol] Get Patrol Sessions Success':
      return {
        ...state,
        loading: false,
        patrolSessions: (action as fromGuardsActions.GetPatrolSessionsSuccess)
          .payload,
      };

    case '[Guard Patrol] Get User Patrol Sessions Success':
      return {
        ...state,
        loading: false,
        userPatrolSessions: (
          action as fromGuardsActions.GetUserPatrolSessionsSuccess
        ).payload,
      };

    case '[Guard Patrol] Get Patrol Violations Success':
      return {
        ...state,
        loading: false,
        patrolViolations: (
          action as fromGuardsActions.GetPatrolViolationsSuccess
        ).payload,
      };

    case '[Guard Patrol] Record Patrol Violation Success':
      return {
        ...state,
        loading: false,
        patrolViolations: [
          ...state.patrolViolations,
          (action as fromGuardsActions.RecordPatrolViolationSuccess).payload,
        ],
      };

    case '[Guard Patrol] Set Current Patrol Session':
      return {
        ...state,
        currentPatrolSession: (
          action as fromGuardsActions.SetCurrentPatrolSession
        ).payload,
      };

    case '[Guard Patrol] Clear Patrol Data':
      return initialGuardPatrolState;

    case '[Guard Patrol] Load User Patrol Data Failure':
    case '[Guard Patrol] Start Patrolling Failure':
    case '[Guard Patrol] End Patrolling Failure':
    case '[Guard Patrol] Get Patrol Sessions Failure':
    case '[Guard Patrol] Get User Patrol Sessions Failure':
    case '[Guard Patrol] Get Patrol Violations Failure':
    case '[Guard Patrol] Record Patrol Violation Failure':
      return {
        ...state,
        loading: false,
        error: (action as any).payload,
      };

    default:
      return state;
  }
}
